import { render } from "./textareaField.vue?vue&type=template&id=5c1eacc6"
import script from "./textareaField.vue?vue&type=script&lang=js"
export * from "./textareaField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__